import request from '@/utils/request'

export const PAYOUT_METHOD_LABELS = {
  vodafone_cash: 'فودافون كاش',
  etisalat_cash: 'اتصالات كاش',
  bank_transfer: 'تحويل بنكي',
  instapay: 'انستاباي',
}

export function payoutMethodLabel(method) {
  if (!method) return ''
  return PAYOUT_METHOD_LABELS[method] || method
}

export function walletOptionLabel(wallet) {
  if (!wallet) return ''
  if (wallet.name) return wallet.name
  const employeeName = wallet.employee && (wallet.employee.name || wallet.employee.full_name)
  if (employeeName) return employeeName
  if (wallet.employee_name) return wallet.employee_name
  return wallet.id ? `محفظة #${wallet.id}` : ''
}

export function payoutOptionLabel(row) {
  if (!row) return ''
  return [row.employee_name, payoutMethodLabel(row.method), row.account_number, row.bank_name]
    .map(part => (part == null ? '' : String(part).trim()))
    .filter(Boolean)
    .join(' — ')
}

export function payoutSourceText(source) {
  if (!source) return ''
  return [payoutMethodLabel(source.method), source.account_number, source.bank_name]
    .map(part => (part == null ? '' : String(part).trim()))
    .filter(Boolean)
    .join(' — ')
}

export function accountSourceText(source) {
  if (!source) return ''
  const code = source.code || ''
  const name = source.name || ''
  if (code && name) return `${code} - ${name}`
  return code || name
}

export function paymentSourceValue(paymentSource) {
  if (!paymentSource) return ''
  if (typeof paymentSource === 'string') return paymentSource
  return paymentSource.value || ''
}

export function voucherErrorMessage(error, fallback) {
  const data = error && error.response && error.response.data
  if (!data) return fallback
  const lines = []
  if (typeof data.message === 'string' && data.message.trim()) lines.push(data.message.trim())
  if (data.errors && typeof data.errors === 'object') {
    Object.keys(data.errors).forEach(key => {
      const value = data.errors[key]
      const parts = Array.isArray(value) ? value : [value]
      parts.forEach(part => {
        const text = part == null ? '' : String(part).trim()
        if (text && !lines.includes(text)) lines.push(text)
      })
    })
  }
  return lines.join(' — ') || fallback
}

export function fieldError(error, field) {
  const errors = error && error.response && error.response.data && error.response.data.errors
  const value = errors && errors[field]
  if (Array.isArray(value)) return value.filter(Boolean).join(' ')
  return value ? String(value) : ''
}

function employeeRows(payload) {
  if (Array.isArray(payload)) return payload
  if (payload && Array.isArray(payload.data)) return payload.data
  if (payload && payload.data && Array.isArray(payload.data.data)) return payload.data.data
  return []
}

export function voucherSourceText(item, payouts = []) {
  if (!item) return ''
  const { source } = item
  const kind = paymentSourceValue(item.payment_source)
  if (kind === 'wallet') return walletOptionLabel(source)
  if (kind === 'employee_payment_account') {
    const loaded = source && (source.method || source.account_number || source.bank_name)
    const payout = loaded
      ? source
      : (payouts || []).find(row => Number(row.id) === Number(item.source_id))
    return payoutSourceText(payout)
  }
  return accountSourceText(source)
}

function joinedCodeName(record) {
  if (!record || typeof record !== 'object') return ''
  const code = record.code == null ? '' : String(record.code).trim()
  const name = record.name == null ? '' : String(record.name).trim()
  if (code && name) return `${code} — ${name}`
  return code || name
}

export function fundSourceParts(item) {
  const type = paymentSourceValue(item && item.fund_source_type)
  if (!type) return null
  if (type === 'customer') {
    return {
      key: 'accounting_fund_customer_line',
      params: { name: (item.customer && item.customer.name) || '' },
    }
  }
  if (type === 'supplier') {
    return {
      key: 'accounting_fund_supplier_line',
      params: { label: joinedCodeName(item.supplier) },
    }
  }
  if (type === 'account') {
    return {
      key: 'accounting_fund_account_line',
      params: { label: joinedCodeName(item.fund_account) },
    }
  }
  if (type === 'gl_account') {
    return {
      key: 'accounting_fund_gl_line',
      params: { label: joinedCodeName(item.fund_gl_account) },
    }
  }
  return null
}

export function chartMovementRows(primary, extras) {
  if (!primary || typeof primary !== 'object') return []
  const rows = [primary]
  const list = Array.isArray(extras) ? extras : []
  list.forEach(row => {
    if (!row || typeof row !== 'object') return
    const duplicate = rows.some(existing => String(existing.id) === String(row.id)
      && String(existing.code || '') === String(row.code || '')
      && String(existing.amount) === String(row.amount))
    if (!duplicate) rows.push(row)
  })
  return rows
}

export function chartMovementLabel(row) {
  return joinedCodeName(row)
}

export function drawerChartIds(rows) {
  const ids = []
  ;(rows || []).forEach(row => {
    if (!row || typeof row !== 'object') return
    if (row.gl_account_id != null && row.gl_account_id !== '') ids.push(row.gl_account_id)
    const account = row.gl_account
    if (account && account.id != null) ids.push(account.id)
  })
  return ids
}

export function paidFromText(item) {
  const row = item && item.paid_from
  if (!row || typeof row !== 'object') return ''
  return joinedCodeName(row)
}

export function receivedByText(item) {
  const row = item && item.received_by
  if (!row || typeof row !== 'object') return ''
  return joinedCodeName(row)
}

export async function fetchActivePayouts() {
  const response = await request.post('/employees/list', {
    with: 'paymentAccounts',
    per_page: 1000,
  })
  const rows = []
  employeeRows(response).forEach(employee => {
    const employeeName = employee.name || employee.full_name || ''
    const accounts = employee.payment_accounts || employee.paymentAccounts || []
    accounts.forEach(row => {
      if (!row || row.is_active !== true) return
      rows.push({ ...row, employee_name: employeeName })
    })
  })
  return rows
}
